import OrderService from "app/services/orderService";
import Confirm from "components/ConfirmModal/Confir";
import Prices from "components/Prices";
import Dash from "containers/dash";
import { useEffect, useState } from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { OrderPorpos } from "./AccountSales";

// interface ValuePorpos {
//   category: string;
//   category_id: number;
//   condition: number;
//   id: number;
//   price: number;
//   market: string;
//   name: string;
//   size: string;
//   thumb: string;
// }

// interface OrderPorpos {
//   created: Date;
//   product: ValuePorpos[];
//   price: Number;
//   ref: String;
// }
const AccountOrder = () => {
  const [orders, setOrders] = useState<OrderPorpos[]>([]);
  useEffect(() => {
    OrderService.get().then((data) => {
      setOrders(data);
    });
  }, []);

  const renderProductItem = (product: any, index: number) => {
    // const { image, name } = product;

    return (
      <div key={index} className="flex py-4 sm:py-7 last:pb-0 first:pt-0">
        <div className="h-24 w-16 sm:w-20 flex-shrink-0 overflow-hidden rounded-xl bg-slate-100">
          <img
            src={product.thumb}
            alt={product.name}
            className="h-full w-full object-cover object-center"
          />
        </div>

        <div className="ml-4 flex flex-1 flex-col">
          <div>
            <div className="flex justify-between ">
              <div>
                <h3 className="text-base font-medium line-clamp-1">
                  {product.name}
                </h3>
                <div className="mt-1 text-sm text-slate-500 dark:text-slate-400 flex items-center">
                  <span
                    className="w-4 h-4 inline-block rounded-full"
                    style={{ backgroundColor: product.color }}
                  ></span>
                  <span className="mx-2 border-l border-slate-200 dark:border-slate-700 h-4 "></span>
                  <span className="">{product.size}</span>
                </div>
              </div>
              <Prices price={product.price} className="mt-0.5 ml-2" />
            </div>
          </div>
          <div className="flex flex-1 items-end justify-between text-sm">
            <p className="text-gray-500 dark:text-slate-400 flex items-center">
              <span className="hidden sm:inline-block">Qty</span>
              <span className="inline-block sm:hidden">x</span>
              <span className="ml-2">1</span>
            </p>

            <div className="flex">
              <button
                type="button"
                className="font-medium text-indigo-600 dark:text-primary-500 "
              >
                Leave review
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderOrder = (order: OrderPorpos, index: number) => {
    return (
      <div
        key={index}
        className="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden z-0 mx-4"
      >
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center p-4 sm:p-8 bg-slate-50 dark:bg-slate-500/5">
          <div>
            <p className="text-lg font-semibold">{order.ref}</p>
            <p className="text-slate-500 dark:text-slate-400 text-sm mt-1.5 sm:mt-2">
              <span>{String(order.created)}</span>
              <span className="mx-2">·</span>
              <span className="text-primary-500">{order.status.value}</span>
            </p>
          </div>
          <div className="mt-3 sm:mt-0">
            {order.status_id == 1 ? (
              <ButtonSecondary
                sizeClass="py-2.5 px-4 sm:px-6"
                fontSize="text-sm font-medium"
                onClick={() => {
                  setOrderId(order.id);
                  setShowCancel(true);
                }}
              >
                Annuler la commande
              </ButtonSecondary>
            ) : null}
          </div>
        </div>
        <div className="border-t border-slate-200 dark:border-slate-700 p-2 sm:p-8 divide-y divide-y-slate-200 dark:divide-slate-700">
          {/* {[PRODUCTS[0], PRODUCTS[1], PRODUCTS[2]].map(renderProductItem)} */}
          {/* {order.order_value?.map(renderProductItem)}
           */}
          {order.product.map((o, i) => {
            // o.map(renderProductItem)
            // const order = o[1] as ValuePorpos[];

            return renderProductItem(o, i);
          })}
        </div>
      </div>
    );
  };

  const [showCancel, setShowCancel] = useState<boolean>(false);

  const [orderId, setOrderId] = useState<number>();
  const cancelHandler = (orderId: number) => {
    OrderService.cancelOrder(orderId).then((data) => {
      if (data.id) {
        const nextOrders = orders.map((order) => {
          if (order.id === orderId) {
            return data;
          } else {
            return order;
          }
        });
        setOrders(nextOrders);
      }
    });
  };
  return (
    <Dash>
      <div className="space-y-10 sm:space-y-12">
        {/* HEADING */}
        <h2 className="text-2xl sm:text-3xl font-semibold">Order History</h2>
        {orders?.map(renderOrder)}
        <Confirm
          key={`cancel`}
          title="Annuler une commande"
          messgae="Cette action est irréversible, Etes vous sur de vouloir annuler cette commande"
          cancelMessgae="Non"
          confirmMessgae="Oui"
          setOpen={setShowCancel}
          open={showCancel}
          orderId={orderId}
          confirmFunc={cancelHandler}
        />
      </div>
    </Dash>
  );
};

export default AccountOrder;
